import { searchPermissionKeys } from '@app/hcs-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
export const PermissionKeyFE_Search_Release = new PermissionKey_FE(searchPermissionKeys.Release);
export const PermissionKeyFE_Search_Beta = new PermissionKey_FE(searchPermissionKeys.Beta);
//# sourceMappingURL=search.js.map